import { createContext } from 'react';

export interface DocumentDataRefresh {
    docId: string;
    revision: number;
}

/** Перечитать локальные данные вкладок после обновления карточки без их перемонтирования. */
export const DocumentDataRefreshContext = createContext<DocumentDataRefresh | undefined>(undefined);
